import {useRef} from 'react';
import {FutureRace} from "./FutureRace";


export const FutureRacesTab = (props) => {
    const racesNames = [...new Set(props.races.sort((race1, race2) => race1.id - race2.id).map(race => race.code))]
    const myRef = useRef();

    return (
        <section ref={myRef} key={props.keyNr}>
            <div className="section-header">
                <div>
                    <h1>Curse viitoare</h1>
                </div>
            </div>
            {
                racesNames.map((name, index) => {
                    const sameCode = props.races.filter(race => race.code === name)
                    return (<FutureRace key={index} type={sameCode.length > 1 ? 'double' : 'single'} myRef={myRef} races={sameCode}/>)
                })
            }
        </section>
    )

}